import { AHSeparator, AHText, Box } from "arkh";
import { DateTime } from "luxon";
import { FormattedMessage } from "react-intl";

export function CalendarTeamWeekItem(props: {
  date: DateTime;
  numberOfEvents: number;
  isFirst: boolean;
}) {
  return (
    <>
      {!props.isFirst ? <AHSeparator spaceTop="medium" /> : null}
      <Box
        spaceTop="medium"
        spaceHorizontal="medium"
        cornerRadius="medium"
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <AHText type="subtitle" color="text-secondary">
          <FormattedMessage
            defaultMessage="W. {value}"
            description="CalendarTeam: Week number"
            values={{
              value: props.date.toFormat("W"),
            }}
          />
        </AHText>
        <AHText type="detail" spaceLeft="small" color="text-secondary">
          <FormattedMessage
            defaultMessage="{value, plural, one {# Event} other {# Events}}"
            description="CalendarTeam: Number of events in a week"
            values={{
              value: props.numberOfEvents,
            }}
          />
        </AHText>
      </Box>
    </>
  );
}
